









import { Vue, Component } from 'vue-property-decorator';
import NewsList from './components/NewsList.vue';
import * as config from './config';
import { BottomTabbar } from '@/components';
@Component({
  name: 'RelatedNews',
  components: {
    NewsList,
    BottomTabbar,
  },
})
export default class RelatedNews extends Vue {
  option = config.OPTHINES;
}
